import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { Router } from '@lit-labs/router';
import '@juvo/ui';
import { store } from './store.js';
import './layouts/site-chrome.js';
import './pages/home-page.js';
import './pages/courses-page.js';
import './pages/course-detail-page.js';
import './pages/auth-pages.js';
import './pages/impact-pages.js';
import './pages/portal-page.js';
import './pages/admin-page.js';
import './pages/about-page.js';
import './pages/donate-page.js';
import './pages/merch-page.js';

@customElement('jv-app-shell')
export class JvAppShell extends LitElement {
  static styles = css`
    :host {
      display: flex;
      flex-direction: column;
      min-height: 100dvh;
    }
    main {
      flex: 1;
    }
  `;

  private router = new Router(this, [
    { path: '/', render: () => html`<jv-home-page></jv-home-page>` },
    { path: '/about', render: () => html`<jv-about-page></jv-about-page>` },
    { path: '/courses', render: () => html`<jv-courses-page></jv-courses-page>` },
    {
      path: '/courses/:slug',
      render: ({ slug }) => html`<jv-course-detail-page slug=${slug ?? ''}></jv-course-detail-page>`,
    },
    { path: '/signup', render: () => html`<jv-signup-page></jv-signup-page>` },
    { path: '/login', render: () => html`<jv-login-page></jv-login-page>` },
    { path: '/impact', render: () => html`<jv-impact-page></jv-impact-page>` },
    { path: '/donate', render: () => html`<jv-donate-page></jv-donate-page>` },
    { path: '/merch/cart', render: () => html`<jv-cart-page></jv-cart-page>` },
    { path: '/merch', render: () => html`<jv-merch-page></jv-merch-page>` },
    { path: '/geeks', render: () => html`<jv-geeks-page></jv-geeks-page>` },
    { path: '/portal', render: () => html`<jv-portal-page section="dashboard"></jv-portal-page>` },
    {
      path: '/portal/dashboard',
      render: () => html`<jv-portal-page section="dashboard"></jv-portal-page>`,
    },
    {
      path: '/portal/courses',
      render: () => html`<jv-portal-page section="courses"></jv-portal-page>`,
    },
    {
      path: '/portal/contribute',
      render: () => html`<jv-portal-page section="contribute"></jv-portal-page>`,
    },
    {
      path: '/portal/credits',
      render: () => html`<jv-portal-page section="credits"></jv-portal-page>`,
    },
    {
      path: '/portal/profile',
      render: () => html`<jv-portal-page section="profile"></jv-portal-page>`,
    },
    { path: '/admin', render: () => html`<jv-admin-page section="courses"></jv-admin-page>` },
    {
      path: '/admin/courses',
      render: () => html`<jv-admin-page section="courses"></jv-admin-page>`,
    },
    {
      path: '/admin/merch',
      render: () => html`<jv-admin-page section="merch"></jv-admin-page>`,
    },
    {
      path: '/admin/metrics',
      render: () => html`<jv-admin-page section="metrics"></jv-admin-page>`,
    },
    {
      path: '/admin/enrollment',
      render: () => html`<jv-admin-page section="enrollment"></jv-admin-page>`,
    },
    {
      path: '/admin/assets',
      render: () => html`<jv-admin-page section="assets"></jv-admin-page>`,
    },
    { path: '/admin/jvc', render: () => html`<jv-admin-page section="jvc"></jv-admin-page>` },
    {
      path: '/admin/partners',
      render: () => html`<jv-admin-page section="partners"></jv-admin-page>`,
    },
    { path: '/*', render: () => html`<jv-not-found-page></jv-not-found-page>` },
  ]);

  connectedCallback() {
    super.connectedCallback();
    this.unsubscribe = store.subscribe(() => this.requestUpdate());
    store.hydrate();
  }

  disconnectedCallback() {
    this.unsubscribe?.();
    super.disconnectedCallback();
  }

  private unsubscribe?: () => void;

  render() {
    return html`
      <jv-site-header></jv-site-header>
      <main>${this.router.outlet()}</main>
      <jv-site-footer></jv-site-footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'jv-app-shell': JvAppShell;
  }
}
